import { useEffect, useState } from "react";
import { useParams } from "react-router";
import type { PublicRecordsResponse } from "../../shared/types";
import { BrandGlyph, BrandWord } from "../components/BrandMark";
import { ApiError, api } from "../lib/api";
import "../styles/setup.css";
import { HostPanel } from "./EmailSteps";
import type { HostKey } from "./hosts";
import { RecCard } from "./parts";

/**
 * The page a records link opens, for whoever runs the business's website: the records to add, each saying whether
 * it is there yet, and where to paste them. It needs no sign-in; the link's long random name is the key.
 */
export function RecordsPage() {
  const { token = "" } = useParams();
  const [data, setData] = useState<PublicRecordsResponse | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [host, setHost] = useState<HostKey>("other");

  useEffect(() => {
    let alive = true;
    api.records
      .get(token)
      .then((d) => {
        if (!alive) return;
        setData(d);
        setHost(d.dns_host ?? "other");
      })
      .catch((e) => alive && setError(e instanceof ApiError ? e.message : "We couldn’t open these records. Refresh to try again."));
    return () => {
      alive = false;
    };
  }, [token]);

  return (
    <div className="setup">
      <div className="stop">
        <span className="brand">
          <BrandGlyph size={30} />
          <BrandWord />
        </span>
      </div>
      {!data ? (
        <div className="sbody center">
          <p className="muted">{error ?? "Loading…"}</p>
        </div>
      ) : (
        <div className="sbody wideL">
          <div className="sq">
            <div className="eyebrow wine">For {data.business}</div>
            <h1>
              Add {data.records.length} records to {data.root}
            </h1>
            <div className="qs">
              <div className="recs">
                {data.records.map((r) => (
                  <RecCard key={`${r.type} ${r.name}`} rec={r} root={data.root} state={r.found ? "found" : "wait"} />
                ))}
              </div>
            </div>
          </div>
          <div className="sstage" style={{ overflow: "auto" }}>
            <HostPanel host={host} detected={data.dns_host} onHost={setHost} root={data.root} records={data.records} />
          </div>
        </div>
      )}
    </div>
  );
}
